import {ref} from 'vue'

export const i18n = ref<any>()
